import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CPPopupComponent } from "../../../../popup/cp-popup/cp-popup.component";
import { NxDialogService, NxModalRef } from "@aposin/ng-aquila/modal";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { STEP2 } from 'src/app/interfaces/motor';
import { CLIENTTYPE, CONSTANTS, GENDER, ID_TYPE_CONFIG, IDTYPE } from 'src/app/shared/enums/index.enum';
import { takeUntil, Subject } from 'rxjs';
import { NricService } from '@services/nric/nric.service';
import { Router } from '@angular/router';
import { BrnoService } from '@services/brno/brno.service';
import { SharedModule } from '@shared/shared.module';
import { SmeCertFormComponent } from '../sme-cert-form/sme-cert-form.component';
import { SstFormDetailsComponent } from '../sst-form-details/sst-form-details.component';
import { Store } from '@ngxs/store';
import { GET_SWITCH_SITE, SAVE_AS_DRAFT, SAVE_CUSTOMER_PARTNER, SET_CUSTOMER_PARTNER_SEARCH_TYPE } from '@store/sat-motor/sat-motor.action';
import moment from 'moment';
import { CpSameAgentInfoComponent } from '@shared/components/modal/cp-same-agent-info/cp-same-agent-info.component';
import { CustomerPartnerFormComponent } from '../customer-partner-form/customer-partner-form.component';
import { SimpleModalComponent } from '@shared/components/modal/simple-modal/simple-modal.component';
import { ScrollToError } from '@shared/classes/scroll-to-error';
import { emailValidator } from '@shared/classes/validators/email.validator';
import { SaveDraftModalComponent } from '@shared/components/modal/save-draft-modal/save-draft-modal.component';
import { SummaryPopupComponent } from 'src/app/popup/summary-popup/summary-popup.component';
import { ErrorModalComponent } from '@shared/components/modal/error-modal/error-modal.component';
import { RESET_ERROR_MESSAGE } from '@store/exception/error.action';

@Component({
  selector: 'app-customer-partner-not-found',
  standalone: true,
  imports: [
    SharedModule,
    CustomerPartnerFormComponent
  ],
  templateUrl: './customer-partner-not-found.component.html',
  styleUrl: './customer-partner-not-found.component.scss'
})
export class CustomerPartnerNotFoundComponent implements OnInit {
  @Input() lov: any;
  @Input() dataSearch: STEP2.SearchDataStore;
  @Input() eInvoiceConsent: boolean = false;
  @Input() autoRenewal: boolean = false;
  @Input() mkagAgent: any;
  @Input() edocConsentInd: boolean = false;
  @Input() emarketingConsentInd: boolean;
  @Output() searchAgain: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() back = new EventEmitter();

  @ViewChild(CustomerPartnerFormComponent) cpFormChildComponent!: CustomerPartnerFormComponent;

  getCountry = CONSTANTS.getCountry();

  dataDetails: any;
  customerPartnerNotFoundForm: FormGroup;
  componentDialogRef?: NxModalRef<CPPopupComponent>;
  componentDialogRefs?: NxModalRef<SummaryPopupComponent>;
  search_mode_address: boolean = true;
  idType2List: any;
  cpSameAgentInfoModal?: NxModalRef<CpSameAgentInfoComponent>;
  infoMessageModal?: NxModalRef<SimpleModalComponent>;
  userInfo: any;
  hideSaveDraftBtn: boolean = false;
  isQuotationGenerated: any;
  isCoverNoteGenerated: any;
  isUpdateQuotation: any;
  isRetrieveActiveQuotation: any;
  cCentricInfo: any;
  isCCentricIssuance: boolean = false;
  isCCentricCPAutoSearch: boolean = false;

  getLabel = CONSTANTS.getIdLabel();

  unsubscribe$ = new Subject<void>();

  constructor(
    private readonly dialogService: NxDialogService,
    private fb: FormBuilder,
    private nricService: NricService,
    private router: Router,
    private brnoService: BrnoService,
    private store: Store
  ) {
  }

  ngOnInit() {
    this.userInfo = this.store.selectSnapshot<any>(state => state.UserState.user);
    this.isQuotationGenerated = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.generateQuotation?.data?.proposalNo);
    this.isCoverNoteGenerated = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step4?.sendToJPJ?.data?.cnoteNo);
    this.isUpdateQuotation = this.store.selectSnapshot<any>((state) => state.SatMotorState.updateQuotation);
    this.isRetrieveActiveQuotation = this.store.selectSnapshot<any>((state) => state.SatMotorState.retrieveQuotation);

    let isCancelReplace = this.store.selectSnapshot<any>(state => state.SatMotorState.motor?.step3?.coverage?.coveragePremium?.cngeNote?.cancelReplaceContractId);
    this.hideSaveDraftBtn = isCancelReplace || this.isQuotationGenerated || this.isCoverNoteGenerated || this.isUpdateQuotation || this.isRetrieveActiveQuotation ? true : false;
    this.cCentricInfo = this.store.selectSnapshot<any>((state) => state.SatMotorState?.cCentricInfo);
    this.isCCentricIssuance = this.store.selectSnapshot<boolean>((state) => state.SatMotorState?.isCCentricIssuance);
    this.isCCentricCPAutoSearch = this.store.selectSnapshot<boolean>((state) => state.SatMotorState?.data?.step2?.isCCentricCPAutoSearch);

    if (this.cCentricInfo && this.isCCentricIssuance && this.isCCentricCPAutoSearch) {
      let cCentricIdType = this.cCentricInfo?.cngeNoteDto?.clientPartner?.idType1 ?? this.cCentricInfo?.clientPartner?.idType1;
      this.dataDetails = {
        clientType: ID_TYPE_CONFIG[cCentricIdType].clientType,
        idType1: cCentricIdType,
        idValue1: this.dataSearch.idValue,
        clientPartnerAddress: {
          clientAddressType: ID_TYPE_CONFIG[cCentricIdType].clientAddressType
        }
      };
    } else {
      this.dataDetails = {
        clientType: this.dataSearch.clientType,
        idType1: this.dataSearch.idType,
        idValue1: this.dataSearch.idValue,
        clientPartnerAddress: {
          clientAddressType: this.dataSearch.clientAddressType
        }
      };
    }

    

    if(this.dataDetails.idType1 === IDTYPE.NRIC && this.dataDetails.idValue1) {
      this.dataDetails.clientDateofBirth = this.getCalculateDateOfBirth(this.dataDetails.idValue1);
    }

    this.customerPartnerNotFoundForm =this.fb.group({
      name:['', Validators.required],
      nationality: [this.isCompany ? 'MAL' : ''],
      idType2:[''],
      idValue2:[''],
      tinNo:['', [Validators.pattern("^[a-zA-Z0-9]*$")]],
      gender:[''],
      maritalStatus:[''],
      dob:[''],
      age:[{value : this.dataDetails.idType1 === IDTYPE.NRIC ? this.getCalculateAge(this.dataDetails.idValue1) : '', disabled: true}],
      mobileNoCode:[''],
      mobileNo:[''],
      fixedLineNoCode:[''],
      fixedLineNo:[''],
      faxNoCode:[''],
      faxNo:[''],
      email:['', emailValidator],
      showMapSwitcher:[true],
      unitNo:[''],
      address1:['',], //Validators.required],
      address2:[''],
      address3:[''],
      postCode:['', Validators.required],
      city:[{value: '', disabled: true}], // need to change disabled = false after connect to BE to get the postcode details
      state:[{value: '', disabled: true}], // need to change disabled = false after connect to BE to get the postcode details
      country:[{value: '', disabled: true}], // need to change disabled = false after connect to BE to get the postcode details
      addressType:[this.isCompany ? 'O' : 'R'],
      clientGeoLatitude: [''],
      clientGeoLongitude: [''],
      clientGeoPlaceId: [''],
      clientGeoPlusCode: [''],
      clientGeoFormattedAddress: [''],
      emarketingConsentInd: [this.emarketingConsentInd]
    });

    if(this.cCentricInfo && this.isCCentricIssuance) {
      this.populateCCentricCPInfo();
    }

  }
  initAddressValidators(){
    let cp = this.customerPartnerNotFoundForm.getRawValue();
    if ([cp.unitNo, cp.address2, cp.address3].find((element) => element && element.length > 0)) {
      this.customerPartnerNotFoundForm.controls['address1'].setValidators(Validators.required);
      this.customerPartnerNotFoundForm.controls['address1'].updateValueAndValidity();
    } else {
      this.clearvalidatoraddr();
    }
    this.customerPartnerNotFoundForm.controls['postCode'].setValidators(Validators.required);
    this.customerPartnerNotFoundForm.controls['postCode'].updateValueAndValidity();
  }

  //clear validator for addr
  clearvalidatoraddr(){
    this.customerPartnerNotFoundForm.controls['address1'].clearValidators();
    this.customerPartnerNotFoundForm.controls['address1'].updateValueAndValidity();
  }

  nextPage() {

    this.initAddressValidators();

    let formValues = this.customerPartnerNotFoundForm.getRawValue();
    let custAge = formValues?.age;

    let validForm = this.cpFormChildComponent.validateForm();

    if(this.customerPartnerNotFoundForm.valid && validForm) {
      console.log("customer partner not found form: ", this.customerPartnerNotFoundForm.getRawValue());

      if(this.dataDetails.idType1 === IDTYPE.OLD_IC && formValues.idType2 !== IDTYPE.NRIC) {
        this.openNricNotUpdatePopup();
        return;
      }

      if(!this.isCompany && formValues.age < 16) {
        this.openPopup("custAge");
        return;
      }

      if( (!this.isCompany) && (custAge < 16 || custAge > 99) ){
        this.openPopup("custAge");
        return;
      }

      //connect to BE to save the not found customer info
      const payload = this.generateSaveCPPayload();
      this.store.dispatch(new SAVE_CUSTOMER_PARTNER(payload)).subscribe(state => {
        if (state.ErrorState.detail.isError) {
          this.dialogService.open(ErrorModalComponent, {
            disableClose: true,
            width: "400px",  data: { e: state.ErrorState.detail },
          }).afterClosed().subscribe((result) => {
              this.store.dispatch(new RESET_ERROR_MESSAGE());
          });
        } else {
          let cpDetails = state.SatMotorState.motor.step2;
          if(cpDetails) {
            this.store.dispatch(new SET_CUSTOMER_PARTNER_SEARCH_TYPE("FOUND"));
            this.router.navigate(['issuance/coverage']);
          }
        }
      })
      
    }else {
      const invalidFields = [];
      Object.keys(this.customerPartnerNotFoundForm.controls).forEach(field => {
        const control = this.customerPartnerNotFoundForm.get(field);
        if (control && control.invalid && (control.dirty || control.touched)) {
          invalidFields.push(field);
        }
      });
      console.log("customer partner form invalid field: ", invalidFields);
      this.customerPartnerNotFoundForm.markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
    }
  }

  generateSaveCPPayload() {
    const formValue = this.customerPartnerNotFoundForm.getRawValue();
    const searchCriteria = this.store.selectSnapshot(state => state.SatMotorState.data.step2.search);
    const date = new Date();
    const effectiveDate = moment(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`, 'YYYY-M-D').format('YYYY-MM-DD');
    const user = this.store.selectSnapshot<string>((state) => state.UserState.user.userId);

    const payload = {
      clientPartner: {
        clientAge: formValue.age,
        clientDateofBirth: formValue.dob ? moment(formValue.dob, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '',
        clientEmail: formValue.email,
        clientGender: formValue.gender,
        clientMobileCode1: formValue.mobileNoCode,
        clientMobileNo1: formValue.mobileNo,
        clientName: formValue.name,
        clientNationality: formValue.nationality,
        clientMaritalStatus: formValue.maritalStatus,
        clientPartnerAddress: {
          clientUnitNo: formValue.unitNo?.trim(),
          clientAddress1: formValue.address1?.trim(),
          clientAddress2: formValue.address2?.trim(),
          clientAddress3: formValue.address3?.trim(),
          clientAddressType: formValue.addressType,
          clientCity: formValue.city,
          clientCountry: formValue.country,
          clientPhoneCode: formValue.fixedLineNoCode,
          clientPhoneNo: formValue.fixedLineNo,
          clientFax1Code: formValue.faxNoCode,
          clientFax1No: formValue.faxNo,
          clientPostcode: formValue.postCode,
          clientState: formValue.state,
          clientGeoLatitude : formValue.clientGeoLatitude,
          clientGeoLongitude : formValue.clientGeoLongitude,
          clientGeoPlaceId : formValue.clientGeoPlaceId,
          clientGeoPlusCode : formValue.clientGeoPlusCode,
          clientGeoFormattedAddress : formValue.clientGeoFormattedAddress
        },
        clientType: this.dataDetails.clientType,
        defaultMailReq: false,
        idType1: this.dataDetails.idType1,
        idType2: formValue.idType2,
        idValue1: this.dataDetails.idValue1,
        idValue2: formValue.idValue2,
        updateCustomerPartner: false,
        clientTinNo: formValue.tinNo,
        clientSstRegInd: formValue.sstRegisteredInd === 'Y' ? true : false,
        clientSstRegNo: formValue.sstNo,
        clientSstRegDate: formValue.sstEffDate && moment(formValue.sstEffDate).isValid() ? moment(formValue.sstEffDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '',
        clientSstDeRegDate: formValue.sstDeRegDate && moment(formValue.sstDeRegDate).isValid() ? moment(formValue.sstDeRegDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '',
        clientSstResidentStatus: formValue.sstResidentStatus,
        clientSstCountry: formValue.sstCountry,
        smeCategory: formValue.smeCategory,
        smeEndDate: formValue.smeEndDate ? moment(formValue.smeEndDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '',
        smeRegisteredInd: formValue.smeRegisteredInd === 'Y' ? true : false,
        smeRegisteredNumber: formValue.smeRegNo,
        smeStartDate: formValue.smeStartDate ? moment(formValue.smeStartDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '',
        emarketingConsentInd: formValue.emarketingConsentInd
      },
      mkagAgent: this.mkagAgent,
      effectiveDate: effectiveDate,
      productType: 'MT',
      operator: user
    }

    return payload;
  }

  goBack() {
    this.back.emit();
  }

  saveAsDraft() {
  this.clearvalidatoraddr();

  let validForm = this.cpFormChildComponent.validateForm();

    if(this.customerPartnerNotFoundForm.valid && validForm) {
      const payload = this.generateSaveCPPayload();
      this.store.dispatch(new SAVE_CUSTOMER_PARTNER(payload)).subscribe(state => {
        if (state.ErrorState.detail.isError) {
          this.dialogService.open(ErrorModalComponent, {
            disableClose: true,
            width: "400px",  data: { e: state.ErrorState.detail },
          }).afterClosed().subscribe((result) => {
              this.store.dispatch(new RESET_ERROR_MESSAGE());
          });
        } else {
          this.store.dispatch(new SAVE_AS_DRAFT({ userId: this.userInfo.userId })).subscribe(state => {
            if (!state?.SatMotorState?.saveAsDraftError) {
              let cpDetails = state.SatMotorState.motor.step2;
              if (cpDetails) {
                this.dialogService.open(SaveDraftModalComponent, {
                  ariaLabel: "A simple dialog",
                  showCloseIcon: false,
                  disableClose: true,
                  autoFocus: false,
                  width: '90vw',
                  maxWidth: '550px',
                  data: {
                    draftNo: state.SatMotorState.draftDetails.proposalNo,
                  },
                })
                .afterClosed().subscribe((result) => {
                  this.store.dispatch(new GET_SWITCH_SITE("SUMMARY_SYS_URL")).subscribe((state) => {
                    window.location.href = state.SatMotorState.data.switchSiteUrl;
                  });
                });
              }
            } else {
              this.infoMessageModal = this.dialogService.open(SimpleModalComponent, {
                showCloseIcon: false,
                disableClose: true,
                width: '95%',
                maxWidth: '400px',
                data: {
                  type: "e-Quotation Saved Failed",
                  message: state?.SatMotorState?.saveAsDraftError,
                  btnOkLabel: "OK",
                },
              });
            }
          })
        }
      });
      
    }else {
      this.customerPartnerNotFoundForm.markAllAsTouched();
      ScrollToError.scrollToError('.ng-invalid[formControlName]');
    }
  }

  toText(value: string): string | null {
    return value ? value.toUpperCase() : null;
  }

  restartSearch() {
    this.searchAgain.emit(true);
  }

  openNricNotUpdatePopup() {
    this.infoMessageModal = this.dialogService.open(SimpleModalComponent, {
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { 
        type: "Warning", 
        message: "NRIC not updated for Policyholder. Please update."
      },
    });
  }

  openAgeNotMetPopup() {
    this.infoMessageModal = this.dialogService.open(SimpleModalComponent, {
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { 
        type: "Warning", 
        message: "Minimum age of the client is not met."
      },
    });
  }

  openPopup(popup_type: any) {

    this.componentDialogRefs = this.dialogService.open(SummaryPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { popup_type: popup_type },
    });
  }

  getCalculateAge(value) {
    return this.nricService.getAge(value);
  }

  populateCCentricCPInfo() {
    let cCentricCPInfo = this.store.selectSnapshot<any>(state => state.SatMotorState?.cCentricInfo?.cngeNoteDto?.clientPartner);

    if (cCentricCPInfo) {
      this.customerPartnerNotFoundForm.get('name').setValue(cCentricCPInfo?.clientName);

      let postcode = cCentricCPInfo?.clientPartnerAddress?.clientPostcode;
      if (postcode) {
        let isValidPostcode = this.lov.clientPostcodeList.some(a => a.code == postcode);
        if(isValidPostcode) {
          this.customerPartnerNotFoundForm.get('postCode').setValue(cCentricCPInfo?.clientPartnerAddress?.clientPostcode);
        }
      }

      if(this.dataDetails.clientType === CLIENTTYPE.INDIVIDUAL) {
        let maritalStatus = cCentricCPInfo?.clientMaritalStatus;
        let isValidMaritalStatus = this.lov?.clientMaritalList.some(a => a.code == maritalStatus);
        if(isValidMaritalStatus) {
          this.customerPartnerNotFoundForm.get('maritalStatus').setValue(maritalStatus);
        }
      }
      
      this.customerPartnerNotFoundForm.get('mobileNo').setValue(this.subString(cCentricCPInfo?.clientMobileNo1, 8));
      this.customerPartnerNotFoundForm.get('fixedLineNo').setValue(this.subString(cCentricCPInfo?.clientPartnerAddress?.clientPhoneNo, 8));
      this.customerPartnerNotFoundForm.get('email').setValue(cCentricCPInfo?.clientEmail);

      this.customerPartnerNotFoundForm.get('address1').setValue(cCentricCPInfo?.clientPartnerAddress?.clientAddress1);
      this.customerPartnerNotFoundForm.get('address2').setValue(cCentricCPInfo?.clientPartnerAddress?.clientAddress2);
      this.customerPartnerNotFoundForm.get('address3').setValue(cCentricCPInfo?.clientPartnerAddress?.clientAddress3);
    }
    
  }

  subString(value, max) {
    if(!value) {
      return null;
    }
    return value.length <= max ? value : value.slice(0, max);
  }

  getCalculateDateOfBirth(value: string): Date | string {
    try {
        return this.nricService.getDateOfBirth(value);
    } catch (error) {
        console.log('Error calculating date of birth:', error);
        return null;
    }
  }


  get isCompany() {
    return this.dataDetails.clientType === CLIENTTYPE.COMPANY;
  }

  hasCoverNoteAccess() {
    if (this.userInfo && this.userInfo.menuAccess) {
      if (this.userInfo.menuAccess.includes('SAT_MT_CN')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
